import { ChangeDetectionStrategy, Component, ElementRef, Renderer2 } from '@angular/core';
import { PrintCardContentComponent } from '../../shared/print-card-content.component';
import { GenericIndexCardStackContentViewModel } from './generic-index-card-stack-content-view-model';

@Component({
  selector: 'app-generic-index-card-stack-content',
  templateUrl: './generic-index-card-stack-content.component.html',
  styleUrls: ['./generic-index-card-stack-content.component.scss'],
  providers: [GenericIndexCardStackContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GenericIndexCardStackContentComponent extends PrintCardContentComponent {
  constructor(
    public override viewModel: GenericIndexCardStackContentViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }
}
